module.exports = __webpack_public_path__ + "static/select-register-here-6d393eb76a8ab43f2eff6eece745867c.png";